import React, { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import Select from 'react-select';
import axios from 'axios';
import { APIURL, TZ } from '../../../Global';
import { sampleList } from './sampleList';
import { useAlert } from 'react-alert';

const PanelShow = (props) => {
    const [panelData, setPanelData] = useState({
        sample: props.type === 'testgroup' ? '' : 'blood',
        name: '',
        note: '',
    });
    const [sampleType, setSampleType] = useState(null)
    const [tests, setTests] = useState([]);
    const [testsList, setTestsList] = useState([]);
    const [error, setError] = useState({
        sample: '',
        tests: '',
    });
    const [isSaving, setIsSaving] = useState(false);
    const alert = useAlert();

    const samples = sampleList.map((item) => ({ value: item, label: item }));

    useEffect(() => {
        if ((panelData.sample !== '' && props.type === 'global') || (props.type === 'testgroup' && props.testGroup.value)) {
            const tokenString = sessionStorage.getItem('usertoken');
            const str = tokenString.replace(/["]+/g, '');
            const formattedSample = panelData.sample.replace(/\s+/g, '_');
            const endPoint = props.type === 'global' ? `lab-test/?sample=${formattedSample}&${TZ}` : `master-test-group/?${TZ}`
            axios
                .get(`${APIURL}/api/v1/staff/${endPoint}`, {
                    headers: {
                        Authorization: 'Token ' + str,
                    },
                })
                .then((res) => {
                    if (res.status === 200 && res.data.status === 'success') {
                        const testsOptions = res.data.tests.length > 0 && res.data.tests.map((test) => ({
                            value: test.id,
                            label: test.test_name,
                        }));
                        setTestsList(testsOptions);
                    } else {
                        alert.error(res.data.message || 'Error fetching tests.');
                    }
                })
                .catch((err) => {
                    alert.error('Error fetching sample data.');
                });
        }
    }, [panelData.sample, props]);

    const handleCategoryClick = (category) => {
        setPanelData((current) => ({
            ...current,
            sample: category,
        }));
    };


    const handleInputChange = (e) => {
        const name = e.target.name
        const val = e.target.value
        setPanelData((current) => ({
            ...current,
            name: val,
        }));
        setError((currentState) => ({
            ...currentState,
            panelName: '',
        }));
    }

    const handleTestChange = (selectedOptions) => {
        setError((currentState) => ({
            ...currentState,
            tests: '',
        }));

        if (!selectedOptions) {
            setTests([]);
            return;
        }

        setTests(selectedOptions);
    };

    const handleSubmit = () => {
        if ((!panelData.sample && props.type === 'global') || panelData.name === "") {
            if (!panelData.sample && props.type === 'global') {
                setError((currentState) => ({ ...currentState, sample: 'Sample is required.' }));
            }
            if (!panelData.name || panelData.name === "") {
                setError((currentState) => ({ ...currentState, panelName: 'Panel Name is required.' }));
            }
            return;
        }
        setIsSaving(true);
        const payload = {
            panel_name: panelData.name,
            ...(props.type === 'global'
                ? { sample: panelData.sample }
                : sampleType && { sample: sampleType.value }
            ),
            ...(props.type === 'testgroup'
                && {
                is_general: true,
                test_group: props.testGroup.value
            }
            ),
            test_ids: tests.map((test) => test.value),
        };

        const tokenString = sessionStorage.getItem('usertoken');
        const str = tokenString.replace(/["]+/g, '');
        const endPoint = props.type === 'testgroup' ? `is_general=true&${TZ}` : `${TZ}`
        axios
            .post(`${APIURL}/api/v1/staff/lab-test/?${endPoint}`, payload, {
                headers: {
                    Authorization: 'Token ' + str,
                },
            })
            .then((res) => {
                if (res.status === 200 && res.data.status === 'success') {
                    alert.success('Panel added successfully!');
                    props.handleSuccess();
                } else {
                    alert.error(res.data.message || 'Failed to add panel.');
                }
            })
            .catch((err) => {
                alert.error('Failed to add panel. Please try again.');
            }).finally(() => {
            setIsSaving(false); 
        });
    };

    return (
        <div>
            <Modal
                {...props}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                backdrop="static"
                keyboard={false}
                show={true}
            >
                <Modal.Header closeButton onHide={props.onClose}>
                    <Modal.Title style={{ fontSize: "18px", fontFamily: "fantasy" }}><b>Add Panel</b></Modal.Title>
                </Modal.Header>
                <Modal.Body style={{ display: "flex" }}>
                    {props.type === 'global' &&
                        <div className="left-side-buttons col-3" style={{ padding: 0 }} >
                            <div className="left-side-buttons-title">Samples</div>
                            <div className="left-side-buttons" style={{ borderRadius: 0, border: "none" }}>
                                {sampleList.map((category) => (
                                    <button
                                        key={category}
                                        className={`category-button ${panelData.sample === category ? "active" : ""}`}
                                        onClick={() => handleCategoryClick(category)}
                                    >
                                        {category}
                                    </button>
                                ))}
                            </div>
                        </div>
                    }
                    <div className={`panel-container ${props.type === 'global' ? 'col-9' : 'col-12'}`}>
                        {props.type === 'global' && <div className='pricing-inputcontainer'>
                            <span>Required sample</span>
                            <input style={{ textTransform: "capitalize" }}
                                value={panelData.sample}
                                disabled
                            />
                        </div>}
                        <div className='pricing-inputcontainer'>
                            <span className='required'>Panel Name</span>
                            <input
                                className={`${error.panelName ? 'has-error-input' : ''}`}
                                name="name"
                                placeholder='Name'
                                value={panelData.name}
                                onChange={(e) => { handleInputChange(e) }}
                            />
                            {error.panelName && <div className="error-message">{error.panelName}</div>}
                        </div>
                        <div className='pricing-inputcontainer'>
                            <span>Tests</span>
                            <Select
                                className='input-container'
                                styles={{
                                    control: (provided) => ({
                                        ...provided,
                                        minHeight: '40px',
                                        border: error.tests ? '1px solid red' : '1px solid #E3E3E3',
                                    }),
                                    menu: (provided) => ({
                                        ...provided,
                                        maxHeight: '200px!important',
                                        zIndex: 9999,
                                    }),
                                    menuList: (provided) => ({
                                        ...provided,
                                        maxHeight: '200px !important',
                                        zIndex: 9999,
                                        overflowY: "auto"
                                    }),
                                }}
                                isMulti
                                value={tests}
                                onChange={handleTestChange}
                                options={testsList}
                                placeholder="Select Tests"
                            />
                            {error.tests && <p style={{ color: 'red' }}>{error.tests}</p>}
                        </div>
                        {props.type === 'testgroup' &&
                            <div className='pricing-inputcontainer'>
                                <span>Sample</span>
                                <Select
                                    className='input-container'
                                    styles={{
                                        control: (provided) => ({
                                            ...provided,
                                            minHeight: '40px',
                                            border: error?.tests ? '1px solid red' : '1px solid #E3E3E3',
                                        }),
                                        menu: (provided) => ({
                                            ...provided,
                                            maxHeight: '200px !important',
                                            zIndex: 100,
                                        }),

                                    }}
                                    value={sampleType}
                                    onChange={(option) => setSampleType(option)}
                                    options={samples}
                                    placeholder="Select sample"
                                />
                            </div>
                        }
                        <div style={{ display: "flex", gap: "10px", margin: "auto 0 0 auto" }}>
                            <button className='add-btn' onClick={props.onClose}>
                                Close
                            </button>
                            <button className='add-btn' onClick={handleSubmit} disabled={isSaving}>
                                {isSaving ? 'Saving...' : 'Save'}
                            </button>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </div>
    );
};

export default PanelShow;